var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNormalSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 54,
    viewBox: "0 0 59 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 27.2988V11.1609C1.4 9.36782 4 5.78161 11.2 5.78161M11.2 5.78161H43.6C44.8 6.37931 47.2 9.72644 47.2 18.3333V27.2988M11.2 5.78161C11.6 4.18774 13.12 1 16 1H44.2C45.4 1.19923 47.8 2.1954 47.8 4.58621M1 26.8447V42.9827C1.4 44.7758 4 48.362 11.2 48.362H43.6C44.8 47.7643 47.2 44.4172 47.2 35.8103V26.8447M44.2 5.78161C44.8 5.18391 46.72 3.98851 49.6 3.98851C53.2 3.98851 58 5.18391 58 12.3563V28.4943M44.2 48.2184C44.8 48.8161 46.72 50.0115 49.6 50.0115C53.2 50.0115 58 48.8161 58 41.6437V25.5057M11.2 48.2184C11.6 49.8123 13.12 53 16 53H44.2C45.4 52.8008 47.8 51.8046 47.8 49.4138",
    stroke: "#435869"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNormalSeat);
export default __webpack_public_path__ + "static/media/ic-normal-seat.293563716a9e067147a91b39f75cac7f.svg";
export { ForwardRef as ReactComponent };